import { useEffect, useState } from 'react';

import { fetchMosOperators, hasMosSwitchersAccess } from '../services/mosSwitchers';

/**
 * MOS operators the user has access to (GET /v1/user/operators). Stays empty for
 * sessions without MOS switchers access, until loaded, or when the call fails.
 */
const useMosOperators = (user) => {
  const [mosOperators, setMosOperators] = useState([]);

  const hasAccess = hasMosSwitchersAccess(user);

  useEffect(() => {
    if (!hasAccess) {
      setMosOperators([]);
      return;
    }

    let isCancelled = false;

    fetchMosOperators()
      .then((operators) => {
        if (!isCancelled) {
          setMosOperators(operators);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('[MOS] operators fetch failed:', error);
      });

    return () => {
      isCancelled = true;
    };
  }, [hasAccess]);

  return mosOperators;
};

export default useMosOperators;
